import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Image, Path, Group, Text, geometry } from '@progress/kendo-drawing';
import { generateDataChartForMySaving } from '@app/features/my-needs/my-needs';
import { formatStringToCurrency } from '@app/features/coverage/coverage';
const { Rect, Point, Size, transform } = geometry;

@Component({
  selector: 'app-range-area-chart-my-saving',
  templateUrl: './range-area-chart-my-saving.component.html'
})
export class RangeAreaChartMySavingComponent implements OnInit, AfterViewInit {
  @Input() data;
  _data: any;
  gender: 1; // male
  plotValue: number;
  formatStringToCurrency: any;
  valueAxisLabels: any;
  isMobile: boolean;

  ngOnInit() {
    this.gender = this.data.gender;
    this._data = generateDataChartForMySaving(this.data.form.value, this.data.userAge);
    this.plotValue = 0;
    this.formatStringToCurrency = formatStringToCurrency;
    this.isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
    this.valueAxisLabels = {
      padding: 3,
      font: this.isMobile ? 'normal 10px Arial, sans-serif' : 'normal 14px Arial, sans-serif',
      color: '#656565'
    };
  }

  ngAfterViewInit() {
    this.data.form.valueChanges.subscribe(formValue => {
      this._data = generateDataChartForMySaving(formValue, this.data.userAge);
    });
  }

  onRender = (args: any, gender: number): void => {
    const chart = args.sender;

    // get the axes
    const valueAxis = chart.findAxisByName('valueAxis');
    const categoryAxis = chart.findAxisByName('categoryAxis');
    const range = valueAxis.range();

    // get the coordinates of the value at which the plot band will be rendered
    const valueSlot = valueAxis.slot(range.min, range.max);
    // get the coordinates of the entire category axis range
    const categorySlot = categoryAxis.slot(this.plotValue);

    // draw the plot band based on the found coordinates
    const line = new Path({
      stroke: {
        color: '#2bcdb5',
        width: 1
      }
    })
      .moveTo(categorySlot.origin)
      .lineTo(categorySlot.origin.x, this.isMobile ? 50 : 80)
      .close();

    const imageRect = new Rect(
      new Point(this.isMobile ? categorySlot.origin.x - 10 : categorySlot.origin.x - 30 / 2, valueSlot.topRight().y + 5),
      this.isMobile ? new Size(18, 22) : new Size(25, 30)
    );

    // Create the image
    const imageUrl = gender === 1
      ? `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzNiA0NC40IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzNiA0NC40OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMjlDQ0I2O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9DQo8L3N0eWxlPg0KPGc+DQoJPGc+DQoJCTxnPg0KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI1LDEwLjljLTEsMC0yLjEtMC41LTIuOS0xLjJDMjEuMyw5LDE5LjksOS4xLDE5LjMsMTBjLTEsMS4zLTIuNSwyLjItNC44LDIuMmgtMS42Yy0xLjEsMC0xLjksMC45LTEuOSwxLjkNCgkJCQl2My4zYzAsNC4zLDIuNiw3LjgsNy4xLDcuOHM3LjEtMy41LDcuMS03Ljh2LTYuNUgyNXoiLz4NCgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yNS4xLDE4YzAsMCwzLjItMS45LDMuMi02LjVjMC0zLjksMC0zLjksMC0zLjljMC0xLjItMC45LTIuMy0yLTIuNWMtMC40LTAuMS0wLjctMC4zLTEtMC42DQoJCQkJYy0xLjctMi41LTQuNS00LTcuOC00aC0wLjhjLTUuMSwwLTkuMyw0LjItOS4zLDkuM3YxLjZjMCwyLjUsMS4zLDUuNCwzLjIsNi43Ii8+DQoJCQk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMTMuNSIgeTE9IjIzLjYiIHgyPSIxMy41IiB5Mj0iMjcuMSIvPg0KCQkJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjIyLjUiIHkxPSIyMy42IiB4Mj0iMjIuNSIgeTI9IjI3LjEiLz4NCgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMy41LDI3LjFMNy44LDI4Yy00LjIsMC42LTcuMyw0LjEtNy4zLDguM3YwLjZ2Mi40YzAsMS4yLDAuOSwyLjMsMi4yLDIuNmw2LjgsMS4zYzUuNiwxLDExLjQsMSwxNywwDQoJCQkJbDYuOC0xLjNjMS4zLTAuMiwyLjItMS4zLDIuMi0yLjZ2LTIuNHYtMC42YzAtNC4xLTMuMS03LjYtNy4zLTguM2wtNS42LTAuOSIvPg0KCQkJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjcuNiIgeTE9IjM5LjQiIHgyPSI3LjYiIHkyPSI0Mi43Ii8+DQoJCQk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMjguNCIgeTE9IjM5LjQiIHgyPSIyOC40IiB5Mj0iNDIuNyIvPg0KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTExLjcsMjcuNGwzLjgsNC41YzEuMywxLjUsMy43LDEuNSw1LDBsMy44LTQuNSIvPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=`
      : `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzOS44IDUxIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzOS44IDUxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMjlDQ0I2O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9DQo8L3N0eWxlPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yMy42LDEyLjVjLTIuMiwwLTMuNywwLTYuNywwcy01LjIsMi4yLTUuMiwyLjJWMjBjMCw1LDMsOSw4LjIsOXM4LjItNCw4LjItOXYtOS43DQoJCQlDMjguMSwxMC4yLDI1LjksMTIuNSwyMy42LDEyLjV6Ii8+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik03LjIsMTEuMkM3LjIsNS4zLDEyLDAuNSwxNy45LDAuNWgxLjZjNCwwLDcuNSwyLDkuNCw1LjJjMi4yLDAsMy43LDEuNSwzLjcsMy43YzAsMCwwLDYuMywwLDEzLjQNCgkJCWMwLDMuNywzLDUuMiwzLDUuMnYwYy0wLjksMS45LTIuNywzLjItNC44LDMuNWwtMS4yLDAuMiIvPg0KCQk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMTQuNyIgeTE9IjI3LjEiIHgyPSIxNC43IiB5Mj0iMzEuMiIvPg0KCQk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMjUuMSIgeTE9IjI3LjEiIHgyPSIyNS4xIiB5Mj0iMzEuMiIvPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjUuMSwzMS4ybDYsMC45YzQuNywwLjcsOC4xLDQuOCw4LjEsOS41djAuN3YyLjhjMCwxLjQtMSwyLjctMi40LDIuOWwtOCwxLjVjLTYsMS4xLTEyLjEsMS4xLTE4LjEsMGwtOC0xLjUNCgkJCWMtMS40LTAuMy0yLjQtMS41LTIuNC0yLjl2LTIuOHYtMC43YzAtNC43LDMuNS04LjgsOC4xLTkuNWw2LTAuOSIvPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTEuNywzMS44bDIuMSw0LjVjMi40LDUuMSw5LjcsNS4xLDEyLjEsMGwyLjEtNC41Ii8+DQoJCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSI4LjciIHkxPSI0NS4zIiB4Mj0iOC43IiB5Mj0iNDkuMSIvPg0KCQk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMzEuMSIgeTE9IjQ1LjMiIHgyPSIzMS4xIiB5Mj0iNDkuMSIvPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTAuMiwzMS44TDksMzEuNmMtMi4xLTAuMy0zLjgtMS43LTQuOC0zLjVsMCwwYzAsMCwzLTEuNSwzLTUuMmMwLTcuMSwwLTguMiwwLTguMnYtMy43Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=`;
    const image = new Image(imageUrl, imageRect);

    const group = new Group();
    group.append(line, image);

    // Draw on the Chart surface to overlay the series
    chart.surface.draw(group);

    // Or as a first element in the pane to appear behind the series
    // chart.findPaneByIndex(0).visual.insert(0, group);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/range-area-chart-my-saving/range-area-chart-my-saving.component.ts